export const getAuthUserId = state => state.auth.userId;
export const getIsAuth = state => state.auth.isAuth;
